import { render, staticRenderFns } from "./InceptionEnglishAssessmentIndex.vue?vue&type=template&id=f639672c&scoped=true"
import script from "./InceptionEnglishAssessmentIndex.vue?vue&type=script&lang=ts"
export * from "./InceptionEnglishAssessmentIndex.vue?vue&type=script&lang=ts"
import style0 from "./InceptionEnglishAssessmentIndex.vue?vue&type=style&index=0&id=f639672c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f639672c",
  null
  
)

export default component.exports